import type { TOC } from '@ember/component/template-only';
import { PrismModal, PrismTable } from '@mylighthouse/prism-ember';
import type { CustomEmberTableColumn } from '@mylighthouse/prism-ember/types/components/prism/table';
import { t } from 'ember-intl';
import type { DisplayChange } from 'lumen/utils/activity-changes';

import styles from './modal-mapping-changes.module.css';

interface SettingsActivityModalMappingChangesSignature {
  Args: {
    columns: CustomEmberTableColumn[];
    onClose: () => void;
    rows: DisplayChange[];
  };
}

// Standalone table for the "view all changes" modal (see TdActivitySummary).
// It's not nested in the main table, so columns/rows are passed in already
// built, no slot repurposing needed.
const SettingsActivityModalMappingChanges: TOC<SettingsActivityModalMappingChangesSignature> =
  <template>
    <PrismModal
      @onClose={{@onClose}}
      @title={{t "settings.activity_history.expanded.all_changes_modal_title"}}
      class={{styles.modal}}
      data-test-id="modal-mapping-changes"
    >
      <:default>
        <PrismTable
          @columns={{@columns}}
          @removeTableBorder={{true}}
          @rows={{@rows}}
        />
      </:default>
    </PrismModal>
  </template>;

export default SettingsActivityModalMappingChanges;
